import PropTypes from 'prop-types';
import { Button, Col, Row, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { JaaSMeeting, JitsiMeeting } from '@jitsi/react-sdk';

import { BaseModal } from 'src/components';
import { lib } from 'src/Utils';
import MeetingContent from './Content';
import appConfig from 'src/config/app';

class DialogStartMeeting extends BaseModal {
  getDialogProps = () => ({
    title: (
      <div>
        Meeting - {this.getDisplayRoomName()}
        <span
          className="link link-blue"
          style={{ marginLeft: '12px' }}
          onClick={() => {
            navigator.clipboard.writeText(
              window.location.origin +
              this.props.generateMeetingPath(this.props.room)
            )
            message.success('Your meeting link has been copied')
          }}
        >
          <CopyOutlined /> Share the link via email, lark, etc.
        </span>
      </div>
    ),
    destroyOnClose: true,
    maskClosable: false,
    width: '100%',
    style: { top: 0, maxWidth: '100%', padding: 0 },
    footer: null,
  })

  getDisplayRoomName = () => {
    const roomName = this.props.room.toUpperCase()
    const prefixRoom = (appConfig.meet.prefix_room || '').toUpperCase()

    return roomName.replace(prefixRoom, '')
  }

  getPreventMessage = () => {
    return new Promise((resolve, reject) => {
      const confirm = window.confirm('Are you sure want to leave the meeting?')
      resolve(confirm
        ? false
        : true)
    })
  }

  onVisibleChanged = (visible) => {
    if (!visible) {
      this.props.onClose()
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.visible !== nextProps.visible) {
      this.setState({ visible: nextProps.visible })
    }
  }

  renderFooter() {
    return (
      <div>
        <Row gutter={[12, 12]}>
        </Row>
      </div>
    )
  }

  renderContent = () => {
    console.log('renderContent', this)

    return (
      <div style={{ height: 'calc(100vh - 104px)' }}>
        <Row style={{ height: '100%', flexDirection: 'column' }}>
          <Col flex="auto" style={{ border: '1px solid black' }}>
            <MeetingContent
              room={this.props.room}
              onClose={this.props.onClose}
            />
          </Col>
        </Row>
      </div>
    )
  }
}

DialogStartMeeting.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  room: PropTypes.string,
}

DialogStartMeeting.defaultProps = {
  visible: false,
  room: '',
}

export default DialogStartMeeting